import { createRoot } from 'react-dom/client'
import { hydrate } from '@tanstack/react-query'
import { queryClient } from './lib/query-client'
import { createAppRouter } from './lib/router'
import { AppProviders } from './lib/AppProviders'
import { applyTheme, resolveTheme, getStoredPreference } from './lib/theme-store'
import './index.css'

// Apply the persisted/system theme before first paint to avoid a flash.
applyTheme(resolveTheme(getStoredPreference()))

void (async () => {
  const initialState = (window as unknown as { __INITIAL_STATE__?: unknown }).__INITIAL_STATE__
  if (initialState) {
    // Warm the React Query cache from the prerendered state. We deliberately use
    // createRoot (NOT hydrateRoot): TanStack Router's match state isn't restored
    // by React-Query-only hydration, so hydrateRoot would suspend + mismatch.
    hydrate(queryClient, initialState)
  }

  const router = createAppRouter({ queryClient })
  await router.load()

  createRoot(document.getElementById('root')!).render(
    <AppProviders router={router} queryClient={queryClient} />,
  )
})()
